import { __assign, __rest } from 'tslib';
import MuiListItemAvatar from '@mui/material/ListItemAvatar';
import { styled } from '@mui/material/styles';
import React from 'react';
import { l as listItemAvatarContextDefaults, L as ListItemAvatarContext } from '../../list-item-avatar-context-2ce6dab0.js';

var ListItemAvatarRoot = styled(MuiListItemAvatar)(function (_a) {
    var theme = _a.theme, size = _a.size;
    var _b = theme.componentsConfig, avatar = _b.avatar, listItemAvatar = _b.listItemAvatar;
    return __assign(__assign({}, (size === 'small' && {
        minWidth: avatar.size.small + listItemAvatar.spacing,
    })), (size === 'large' && {
        minWidth: avatar.size.large + listItemAvatar.spacing,
    }));
});
var ListItemAvatar = React.forwardRef(function ListItemAvatar(_a, ref) {
    var _b = _a.size, size = _b === void 0 ? listItemAvatarContextDefaults.size : _b, restProps = __rest(_a, ["size"]);
    var childContext = React.useMemo(function () { return ({ size: size }); }, [size]);
    return (React.createElement(ListItemAvatarContext.Provider, { value: childContext },
        React.createElement(ListItemAvatarRoot, __assign({}, restProps, { size: size, ref: ref }))));
});

export { ListItemAvatar as default };
